import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { assetName, useAssets } from "@/features/matches";

import type { AssetView } from "./AssetView";

type AssetKind = "heroes" | "items";

const fallbackName = {
  heroes: (id: number) => msg({ id: "analysis.asset.unknown_hero", message: `Hero #${id}` }),
  items: (id: number) => msg({ id: "analysis.asset.unknown_item", message: `Item #${id}` }),
} as const;

// Поиск героя или предмета по id в справочнике `GET /api/matches/assets`. Название — пока
// всегда английское (`assetName`), запасное «Герой #id» — на языке интерфейса.
// Перерисовывается при смене языка (`useLingui`) и после загрузки справочника.
export const useAssetLookup = (kind: AssetKind): ((id: number) => AssetView) => {
  const { i18n } = useLingui();
  const { data } = useAssets();
  const list = data?.[kind];
  return (id: number) => {
    const asset = list?.find((entry) => entry.id === id);
    return asset === undefined
      ? { id, name: i18n._(fallbackName[kind](id)), iconUrl: null, slot: null }
      : {
          id,
          name: assetName(asset.name),
          iconUrl: asset.icon_url,
          slot: "slot" in asset ? asset.slot : null,
        };
  };
};
